import { msg } from 'gt-react';
import { EnvelopeSimpleIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';

const SampleLibraryPage = lazyRouteComponent(
  () => import('./SampleLibraryPage'),
  'SampleLibraryPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/sample-library',
  staticData: {
    app: {
      nav: {
        label: msg('Sample Library', {
          context: 'sidebar nav label, Ship and Debit Admin section',
        }),
        icon: <EnvelopeSimpleIcon className="h-4 w-4" weight="fill" />,
        group: 'Ship and Debit Admin',
        order: 40,
      },
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.SD849Response },
        ],
      },
    },
  },
  component: SampleLibraryPage,
  loader: () => ({
    crumb: msg('Sample Library', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SD849Response,
    });
  },
});
